import React from "react";
import { Box } from "@mui/material";
import ChatBotContainer from "../../components/common/chat/chatBotContainer";

function ChatbotPage() {
  const [fullScreen, setFullScreen] = React.useState(true);

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: "100vh", sm: "100vh", md: "90vh" },
        minHeight: { xs: "100vh", sm: "100vh", md: "90vh" },
        maxHeight: { xs: "100vh", sm: "100vh", md: "90vh" },
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center",
        backgroundColor: "transparent",
        padding: { xs: 0, sm: 0, md: "16px" },
        overflow: "hidden",
      }}
    >
      <ChatBotContainer fullScreen={fullScreen} setFullScreen={setFullScreen} />
    </Box>
  );
}

export default ChatbotPage;
